import { useEffect, useRef, useState } from "react";
import { ChevronDown, Check } from "lucide-react";

const FilterDropdown = ({ value, onChange, options, placeholder, width = 220 }) => {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const selected = options.find((opt) => opt.value === value);

  return (
    <div ref={wrapperRef} style={{ position: "relative", width }}>
      <button
        type="button"
        onClick={() => setOpen((p) => !p)}
        className="w-full flex items-center justify-between px-4 py-[10px] bg-card border border-border rounded-lg text-sm text-foreground cursor-pointer text-left"
      >
        <span>{selected?.label || placeholder}</span>
        <ChevronDown
          className={`w-4 h-4 text-muted-foreground transition-transform duration-150 ${
            open ? "rotate-180" : ""
          }`}
        />
      </button>

      {open && (
        <div
          className="absolute left-0 right-0 bg-popover border border-border rounded-[10px] shadow-lg p-[6px] z-20 overflow-y-auto"
          style={{ top: "calc(100% + 6px)", maxHeight: "260px" }}
        >
          {options.map((opt) => {
            const isSelected = opt.value === value;
            return (
              <button
                key={opt.value}
                type="button"
                onClick={() => {
                  onChange(opt.value);
                  setOpen(false);
                }}
                className={`w-full flex items-center gap-[10px] px-3 py-[10px] border-none rounded-md cursor-pointer text-sm text-foreground text-left hover:bg-accent ${
                  isSelected ? "bg-muted" : "bg-transparent"
                }`}
              >
                <span className="w-4 flex items-center">
                  {isSelected && (
                    <Check className="w-[14px] h-[14px] text-foreground" />
                  )}
                </span>
                <span>{opt.label}</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default FilterDropdown;
